import React from 'react';
import tinycolor2 from 'tinycolor2';

import Buttonlink from '../../elements/ButtonLink';
import CollapsableCategory from '../../elements/CollapsableCategory/CollapsableCategory';
import Screen from '../Screen';
import Scrollable from '../../elements/Scrollable';
import SelectableFilterItem from '../../elements/SelectableFilterItem/SelectableFilterItem';
import TopBarEvent from '../../elements/TopBar/TopBarEvent';
import { max, memoize } from 'lodash';

export default class FilterScreen extends React.Component {
    constructor(props) {
        super(props);

        let expandedTags = _.compact([this.props.expandTag]);
        if (!expandedTags.length) {
            expandedTags = _(this.props.filterParams.tags || {})
                .map((values, tag) => (values.length ? tag : null))
                .compact()
                .value();
        }
        if (!expandedTags.length) {
            expandedTags = _.compact([(_(this.props.tags).first() || {}).name]);
        }

        this.state = {
            expandedTags,
            originalFilter: this.props.filterParams,
        };

        this.getMaxOptionsCount = memoize((options) => max(options.map((o) => o.count ?? 0)) ?? 0);
    }
    render() {
        let { i18n, event } = this.props,
            header = (
                <div>
                    <TopBarEvent event={event} onReturnClick={this.handleCancel.bind(this)}>
                        {i18n['label.filter']}
                    </TopBarEvent>
                    <hr />
                </div>
            ),
            footer = (
                <div>
                    <hr />
                    <div className="content">
                        <Buttonlink style={event._local.styles.button} onClick={this.handleApplyFilter.bind(this)}>
                            <span>
                                {i18n['button.view.results']}
                                <span>&nbsp;({this.props.exhibitors.length})</span>
                            </span>
                        </Buttonlink>
                        {this.props.recommendedFilter ? (
                            <Buttonlink
                                onClick={this.handleApplyRecommendedFilter.bind(this)}
                                style={{
                                    fontWeight: 'bold',
                                    backgroundColor: 'white',
                                    border: 0,
                                }}>
                                {i18n['button.filter-recommended']}
                            </Buttonlink>
                        ) : null}
                    </div>
                </div>
            );

        return (
            <Screen header={header} footer={footer}>
                <Scrollable>
                    {_(this.props.tags)
                        .map((tag) => {
                            let expanded = _.includes(this.state.expandedTags, tag.name),
                                selectedItemsCount = _(this.props.filterParams).get(`tags[${tag.name}]`, []).length,
                                title = tag.name;

                            if (!expanded && selectedItemsCount) {
                                // TODO: add missing translation here
                                title = (
                                    <span>
                                        {title}
                                        <i
                                            className="marginLeft"
                                            style={{
                                                fontWeight: 'normal',
                                            }}>
                                            [{selectedItemsCount}&nbsp;selected]
                                        </i>
                                    </span>
                                );
                            }

                            return (
                                <CollapsableCategory
                                    title={title}
                                    flagColor={event.settings.primary_color}
                                    expanded={expanded}
                                    disabled={!tag.options.length}
                                    key={tag.name}
                                    onChange={this.handleCollapseChange.bind(this, tag.name)}>
                                    <ul className="list">
                                        {tag.options.map((option) => {
                                            // console.log(option);
                                            let isChecked = _(this.props.filterParams).chain().get(`tags[${tag.name}]`, []).includes(option.name).value(),
                                                lightColor = tinycolor2(option.color).lighten(30).toString(),
                                                maxCount = this.getMaxOptionsCount(tag.options);

                                            return (
                                                <li key={option.name}>
                                                    <SelectableFilterItem
                                                        checked={isChecked}
                                                        color={option.color}
                                                        count={option.count}
                                                        percentage={maxCount ? option.count / maxCount : 0}
                                                        iconCount="img/member.png"
                                                        onChange={this.handleSelectionChange.bind(this, tag, option)}>
                                                        {option.name}
                                                    </SelectableFilterItem>
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </CollapsableCategory>
                            );
                        })
                        .value()}
                </Scrollable>
            </Screen>
        );
    }
    handleApplyRecommendedFilter() {
        if (this.props.recommendedFilter) {
            app.store.dispatch(app.actions.exhibitors.applyRecommendedFilter(this.props.event.id));
            this.setState({
                expandedTags: this.props.recommendedFilter.map((tag) => tag.name),
            });
        }
    }
    handleCollapseChange(tagName, expanded) {
        if (expanded) {
            this.setState({
                expandedTags: [...this.state.expandedTags, tagName],
            });
        } else {
            this.setState({
                expandedTags: this.state.expandedTags.filter((tag) => tag != tagName),
            });
        }
    }
    handleApplyFilter() {
        // no need to apply, since the filter it's already set on the store
        this.props.onClose();
    }
    handleCancel() {
        // restore filter value when screen opened
        app.store.dispatch(app.actions.exhibitors.setFilter(this.props.event.id, this.state.originalFilter));
        if (this.props.onClose) {
            this.props.onClose();
        }
    }
    handleSelectionChange(tag, option, checked) {
        let { filterParams } = this.props;

        if (checked) {
            app.store.dispatch(app.actions.exhibitors.addFilterTagOption(this.props.event.id, tag.name, option.name));
        } else {
            app.store.dispatch(app.actions.exhibitors.removeFilterTagOption(this.props.event.id, tag.name, option.name));
        }
    }
}
